// Italian translations.

const it = {
  nav: {
    howItWorks: "Come funziona",
    features: "Funzionalità",
    updates: "Aggiornamenti",
    useSpotDrop: "Usa SpotDrop",
    langLabel: { en: "Inglese", mt: "Maltese (Malti)", it: "Italiano" },
  },
  hero: {
    badge: "Attivo a Malta",
    headline: "Trova parcheggio prima che sparisca.",
    sub: "Parcheggi in tempo reale, lasciati e presi dai guidatori in tutta Malta. Lascia il tuo posto quando parti, trovane uno quando non ce l'hai.",
    ctaPrimary: "Usa SpotDrop",
    ctaSecondary: "Come funziona",
    ctaPlayAlt: "Disponibile su Google Play",
    ctaPlayNote: "App Android · gratis",
    ctaInstallWeb: "Installa la Web App",
    trust: { free: "Gratis", malta: "Fatto per Malta", nosignup: "Nessuna registrazione" },
  },
  how: {
    eyebrow: "Come funziona",
    title: "Tre semplici passaggi per ogni guidatore a Malta.",
    subtitle: "Sia che tu stia partendo o cercando.",
    card1: { tag: "01 · Lascia", title: "Stai lasciando un posto?", desc: "Lascia il tuo posto prima di partire, così il prossimo guidatore può prenderlo subito." },
    card2: { tag: "02 · Trova", title: "Cerchi parcheggio?", desc: "Vedi i parcheggi liberarsi sulla mappa in tempo reale nel momento in cui i guidatori lasciano un posto." },
    card3: { tag: "03 · Passaggio", title: "Incontri il prossimo guidatore?", desc: "Scegli \"Posso aspettare\" o \"Non posso aspettare\" così il guidatore in arrivo sa cosa aspettarsi — passaggi chiari e onesti." },
  },
  features: {
    eyebrow: "Funzionalità",
    title: "Costruito come una griglia di parcheggi nativa di Malta.",
    tag: "Progettato per i guidatori di tutti i giorni",
    card1: { title: "Mappa live in tempo reale", desc: "Vedi i posti apparire sulla mappa nel momento in cui un guidatore libera un parcheggio vicino a te." },
    card2: { title: "Sistema di localizzazione intelligente", desc: "Precisione ottimizzata per le strade strette di Malta." },
    card3: { title: "Aree Blue Badge, Loading e Moto", desc: "Lascia e trova posti Normali, Blue Badge, Loading e Moto — rispetta le regole locali." },
    card4: { title: "Ricorda dove hai parcheggiato", desc: "Salva la posizione del parcheggio e apri le indicazioni a piedi verso la tua auto." },
    card5: { title: "Veloce e semplice", desc: "Due tocchi per lasciare. Due tocchi per prendere. Tutto qui." },
    card6: { title: "Guidato dalla comunità", desc: "Ogni guidatore a Malta rende la rete più intelligente." },
  },
  showcase: {
    eyebrow: "Dentro l'app",
    title: "Uno sguardo dentro SpotDrop.",
    sub: "Tre schermate. Una missione — mai più giri per trovare parcheggio.",
    ctaCopy: "SpotDrop è attivo a Malta. Aprilo e provalo.",
    ctaBtn: "Usa SpotDrop",
    liveNow: "Attivo ora",
    liveTitle: "Funzioni già disponibili oggi",
    live1: { title: "Assistente Parcheggio", desc: "Dì dove stai andando — trova il parcheggio migliore e ti guida a piedi.", cta: "Trova parcheggio" },
    live2: { title: "Salva l'Auto", desc: "Salva dove hai parcheggiato e torna indietro a piedi senza cercarla.", cta: "Salva l'auto" },
    live3: { title: "Posti della community", desc: "I guidatori lasciano il posto quando partono, così ne prendi uno subito.", cta: "Vedi i posti attivi" },
    mockup1: { tag: "01 · Mappa live", title: "Parcheggi in tempo reale", liveSpots: "Posti attivi", leavingIn5: "Parto tra 5 min", leavingIn10: "Parto tra 10 min" },
    mockup2: {
      tag: "02 · Lascia", title: "Sto lasciando un posto", leavingLabel: "Parto tra",
      min5: "5 min", min10: "10 min", min15: "15 min",
      hint: "I guidatori vicini lo vedranno sulla mappa", dropBtn: "Lascia il posto",
      doneTitle: "Posto lasciato", doneSub: "I guidatori vicini possono vedere il tuo posto sulla mappa.",
    },
    mockup3: {
      tag: "03 · Passaggio", title: "Posso aspettare / Non posso aspettare",
      headerTitle: "Passaggio", arrivingLabel: "Guidatore in arrivo",
      arrivingName: "Luca · Fiat 500 Bianca", arrivingMeta: "Targa JFK-224 · 120m di distanza",
      prompt: "Puoi aspettare?", subprompt: "Dì cosa aspettarsi",
      canWait: "Posso aspettare", canWaitDesc: "Resto finché arriva Luca.",
      cantWait: "Non posso aspettare", cantWaitDesc: "Parto ora — il primo guidatore lo prende.",
      footer: "Passaggi onesti mantengono la mappa equa per tutti.",
    },
  },
  roadmap: {
    eyebrow: "Roadmap",
    title: "Cosa stiamo costruendo dopo.",
    sub: "Uno sguardo alle cose su cui stiamo lavorando. Consegnate una strada alla volta.",
    chipLive: "Attivo",
    chipSoon: "Prossimamente",
    footnote: "Elementi della roadmap, non un impegno. SpotDrop è una piattaforma di informazione e comunità — i parcheggi pubblici non sono mai riservati o garantiti.",
    item1: { title: "Lascia un parcheggio", desc: "Condividi il tuo posto nel momento in cui parti." },
    item2: { title: "Prendi un posto", desc: "Prendi un posto libero sulla mappa live prima che ci arrivi qualcun altro." },
    item3: { title: "Affitto di parcheggi privati", desc: "Posti mensili da proprietari verificati." },
    item4: { title: "Salva la posizione della mia auto", desc: "Non perdere mai più dove hai parcheggiato." },
    item5: { title: "Zone preferite", desc: "Avvisi intelligenti per le strade che ti interessano." },
    item6: { title: "Punti e reputazione della comunità", desc: "Premia i contributori attivi e affidabili." },
    item7: { title: "Protezione anti-spam e anti-bot", desc: "Guidatori veri, posti veri." },
    item8: { title: "Modalità Eventi / Spiaggia / Festival", desc: "Individua l'affollamento per feste, festival e giornate al mare." },
    item9: { title: "Sostieni SpotDrop", desc: "Gratis per la comunità. Supporto opzionale per aiutarci a migliorare." },
    item10: { title: "Piano sostenitori (futuro)", desc: "Vantaggi opzionali per sostenere il progetto." },
  },
  updates: {
    eyebrow: "Aggiornamenti",
    title: "Ricevi aggiornamenti",
    sub: "SpotDrop è attivo e gratuito. Lascia la tua email se vuoi ricevere aggiornamenti occasionali — nuove funzionalità, aggiornamenti sulla copertura e novità importanti di SpotDrop.",
    field: {
      name: "Il tuo nome", namePlaceholder: "Alex",
      email: "Email", emailPlaceholder: "[email protected]",
      area: "Zona a Malta", areaPlaceholder: "Sliema, St Julian's, La Valletta…",
    },
    submit: "Iscriviti",
    submitting: "Iscrizione in corso...",
    successTitle: "Sei nella lista degli aggiornamenti.",
    successBody: "Abbiamo salvato la tua email. Invieremo solo notizie occasionali di SpotDrop.",
    alreadyOn: "Sei già nella lista degli aggiornamenti.",
    alreadyBody: "Questa email è già salvata. Invieremo solo notizie occasionali di SpotDrop.",
    launchNote: "Attivo a Malta · Gratis",
  },
  footer: {
    tagline: "La rete di parcheggi guidata dalla comunità per Malta.",
    updates: "Ricevi aggiornamenti",
    terms: "Termini",
    privacy: "Privacy",
    disclaimer: "Disclaimer",
    instagramAlt: "Segui SpotDrop su Instagram",
    copyright: "© {year} SpotDrop Malta. Tutti i diritti riservati.",
  },
  legal: {
    terms: {
      title: "Termini di utilizzo",
      intro: "Questi termini regolano l'uso di SpotDrop. Leggili prima di utilizzare il servizio.",
      notice: "Questo documento è attualmente mantenuto in inglese. Una versione tradotta sarà disponibile a breve.",
    },
    privacy: {
      title: "Informativa sulla privacy",
      intro: "Prendiamo sul serio la tua privacy. Ecco come SpotDrop gestisce i tuoi dati.",
      notice: "Questo documento è attualmente mantenuto in inglese. Una versione tradotta sarà disponibile a breve.",
    },
    disclaimer: {
      title: "Disclaimer",
      intro: "SpotDrop è una piattaforma di informazione e comunità. I parcheggi pubblici non sono mai riservati o garantiti.",
      notice: "Questo documento è attualmente mantenuto in inglese. Una versione tradotta sarà disponibile a breve.",
    },
  },
  common: { close: "Chiudi", cancel: "Annulla", back: "Indietro", save: "Salva", language: "Lingua", active: "Attivo" },
};

export default it;
